import {getDateTimeFormatter} from "../factory/formatters/get-date-time-formatter";
import {booleanFormatter} from "../factory/formatters/boolean-formatter";
import {getFieldType} from "../common/get-field-type";
import {getNumericFormatter} from "../factory/formatters/get-numeric-formatter";
import {chain} from "../../../utils/fs";
import {roundTo} from "../common/formatters/numeric/round-to";

// used for both scatter plot and bubble chart
export const getScatterFormatters = ({tile, rawData, timezone}) => {
    const dimFieldType = getFieldType(tile.dimensionField);
    const isDimensionRealDate = dimFieldType === "date" && typeof rawData.series[0].name === "number";
    const dimensionFormatter = isDimensionRealDate ? getDateTimeFormatter(tile.dimensionField.dateProperties, timezone) : dimFieldType === "bool" ? booleanFormatter : (v) => v;
    const cGroupFieldFormatter = (groupField) =>
        groupField
            ? {
                  date: groupField?.isDateGroupCategory ? (v) => v : getDateTimeFormatter(groupField.dateProperties, timezone),
                  bool: booleanFormatter,
              }[getFieldType(groupField)] || ((v) => v)
            : (v) => v;
    const colorGroupFormatter = cGroupFieldFormatter(tile.colorGroupField);
    const shapeGroupFormatter = cGroupFieldFormatter(tile.shapeGroupField);

    let measurementFormatters = {};
    let tooltipValueFormatters = {};

    [tile.xAxisField, tile.yAxisField, tile.zAxisField]
        .filter((v) => v)
        .forEach((f, i) => {
            const numericProperties = {
                ...f?.numericProperties,
                currencyOverrides: tile?.currencyOverrides,
            };
            const isAggCount = f?.aggregationFunc?.startsWith("Count");

            const numericFormatter = getNumericFormatter({
                numericProperties,
                autoRound: true,
                useDefaultCountFormat: isAggCount,
            });
            const tooltipValueFormatter = getNumericFormatter({
                numericProperties,
                useDefaultCountFormat: isAggCount,
            });

            measurementFormatters[f.id] = (v) =>
                v != null &&
                chain(
                    v,
                    (v) => (numericProperties?.displayType === "Percentage" ? v * 100 : v),
                    (v) => (numericProperties?.decimalPlaces != null ? roundTo(v, numericProperties.decimalPlaces) : roundTo(v, 2)),
                    (v) => numericFormatter(v)
                );

            tooltipValueFormatters[f.id] = (v) =>
                v != null &&
                chain(
                    v,
                    (v) => (numericProperties?.displayType === "Percentage" ? v * 100 : v),
                    (v) => (numericProperties?.decimalPlaces != null ? roundTo(v, numericProperties.decimalPlaces) : roundTo(v, 2)),
                    (v) => tooltipValueFormatter(v)
                );
        });

    const dateTimeFormatter = getDateTimeFormatter({format: "MMM d, yyyy"}, timezone);

    return {
        dimensionFormatter,
        measurementFormatters,
        colorGroupFormatter,
        shapeGroupFormatter,
        tooltipValueFormatters,
        dateFormatter: (v) => v != null && dateTimeFormatter(v),
        percentFormatter: (v) => roundTo(v, 1) + "%",
    };
};
